<script setup lang="ts">
    const cartStore = useCartStore();
    const { totalItems } = storeToRefs(cartStore);
</script>
<template>
    <span
        v-if="totalItems > 0"
        class="atm-cart-items-bubble absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-woom-red font-mono text-[11px] text-woom-white lg:right-0 lg:top-0">
        {{ totalItems }}
    </span>
</template>
